import "./index.scss";

export function ActionButton(props: React.PropsWithChildren<{ onClick?: () => void }>) {
    return (
        <div className="action-button flex-row flex-row--center-center" onClick={props.onClick}>
            {props.children}
        </div>
    );
}